export enum StandardDonationState {
  ENQUEUED = 'enqueued',
  ACCEPTED = 'accepted',
  EN_ROUTED = 'en_routed',
  ARRIVED = 'arrived',
  EN_ROUTED_TO_STORE = 'en_routed_to_store',
  ARRIVED_AT_STORE = 'arrived_at_store',
  COMPLETED = 'completed',
  DECLINED = 'declined',
  CANCELED = 'canceled',
  DONOR_CANCELLED = 'donor_cancelled',
}
